import { SortOrderTypePublicItems } from "enums";
import { ItemSearchOptions } from "models";
import React, { useEffect } from "react";

type PROPS = {
  options: ItemSearchOptions;
  onChange: () => void;
};

const ItemListSearchSortSelect: React.FC<PROPS> = (props) => {
  const [sortOrder, setSortOrder] = React.useState<string>("");

  useEffect(() => {
    const tmp = props.options.sort_order ?? "";
    setSortOrder(tmp);
  }, [props.options.sort_order]);

  return (
    <select
      className="border border-gray-600 rounded py-2 cursor-pointer"
      value={sortOrder}
      onChange={(e) => {
        const value = e.target.value;
        props.options.sort_order = value;
        setSortOrder(value);

        props.onChange();
      }}
    >
      <option value={SortOrderTypePublicItems.UPDARE_DATE_NEW}>新着順</option>
      <option value={SortOrderTypePublicItems.CORP_NAME_ASC}>会社名昇順</option>
      <option value={SortOrderTypePublicItems.CORP_NAME_DESC}>
        会社名降順
      </option>
      <option value={SortOrderTypePublicItems.PRICE_HIGH}>価格が高い順</option>
      <option value={SortOrderTypePublicItems.PRICE_LOW}>価格が低い順</option>
    </select>
  );
};

export default ItemListSearchSortSelect;
